import React, { Component } from 'react';
import { Radio, Input } from 'antd';
import {bindActionCreators} from 'redux';
import {request} from '../utils/Util'
import {connect} from 'react-redux';
import myEmitter from "../component/my-events";
import {FormattedMessage, injectIntl} from 'react-intl';
import {Match} from "../component/Match";
import {Reading} from "../component/Reading";
import {Science} from "../component/Science";
import {English} from "../component/English";
import * as setAnswer from "../actions/evaluation";
import demo from '../imgs/demo.jpg'
import './QuestionItem.css';
const { TextArea } = Input;
const RadioGroup = Radio.Group;

class Instr extends Component {

    render() {
        const {evaluation,currentEvaluation} = this.props;
        var currnt = evaluation.datas.content_object_content ? evaluation.datas.content_object_content.units[0] : null;
        return (
            <div className='questionItem'>
                {
                    // math
                    currnt && currnt.test === 'math' &&
                    <div className='content'>
                        Begin Mathematics Test—60 minutes, 60 questions
                        <br/>
                        Solve each problem, choose the correct answer, and then select your answer. Select the Next button.
                        Do not linger over problems that take too much time. Solve as many as you can; then return to the others in the time you have left for this test.
                        You may use your calculator for any problems you choose, but some of the problems may best be done without using a calculator.
                        Note: Unless otherwise stated, all of the following should be assumed.
                        <br/>
                        Illustrative figures are NOT necessarily drawn to scale.
                        Geometric figures lie in a plane.
                        The word line indicates a straight line.
                        The word average indicates arithmetic mean.
                        <br/>
                        Select the Next button to proceed.
                    </div>

                }
                {
                    // English
                    currnt && currnt.test === 'english' &&
                    <div className='content'>
                        Begin English Test—45 minutes, 75 questions
                        <br/>
                        In the five passages that follow, certain words and phrases are underlined and highlighted. On the right-hand side of the screen, you will find alternatives for the underlined and highlighted part. In most cases, you are to choose the one that best expresses the idea, makes the statement appropriate for standard written English, or is worded most consistently with the style and tone of the passage as a whole. If you think the original version is best, choose “NO CHANGE.” In some cases, you will find on the right-hand side of the screen a question about the underlined and highlighted part. You are to choose the best answer to the question.
                        You will also find questions about a section of the passage, or about the passage as a whole. These questions do not refer to an underlined portion of the passage, but rather refer to a letter or letters, a number or numbers, or an asterisk within square brackets [ ].
                        <br/>
                        For each question, choose the alternative you consider best, select the circle next to your answer, then select the Next button. Read each passage through once, using the scroll bar to see the entire passage, before you begin to answer the questions that accompany the passage. For many of the questions, you must read several sentences beyond the question to determine the answer. Be sure that you have read far enough ahead each time you choose an alternative.
                        Select the Next button to proceed.
                    </div>

                }
                {
                    // Reading
                    currnt && currnt.test === 'reading' &&
                    <div className='content'>
                        Begin Reading Test—35 minutes, 40 questions
                        <br/>
                        There are several passages in this test. Each passage is accompanied by several questions. Some passages are grouped within a single scrollable window and the corresponding questions will refer to Passage A, Passage B, or both passages.
                        Read each passage through once, using the scroll bar to see the entire passage, before you begin to answer the questions that accompany the passage. After reading a passage, choose the best answer to each question, select the circle next to it, then select the Next button. You may refer to the passages as often as necessary.
                        Select the Next button to proceed.
                    </div>

                }
                {
                    // Science
                    currnt && currnt.test === 'science' &&
                    <div className='content'>
                        Begin Science Test—35 minutes, 40 questions
                        <br/>
                        There are several passages in this section. Each passage is followed by several questions. Read each passage through once, using the scroll bar to see the entire passage, before you begin to answer the questions that accompany it. After reading a passage, choose the best answer to each question, select the circle next to it, then select the Next button. You may refer to the passages as often as necessary.
                        You are NOT permitted to use a calculator on this section.
                        Select the Next button to proceed.
                    </div>

                }
            </div>
        );
    }
}
Instr = connect((state) => ({
    evaluation: state.evaluation,
    currentEvaluation: state.currentEvaluation,
}), (dispatch) => ({
}))(Instr);


class Info extends Component {
    render() {

        const {evaluation,currentEvaluation} = this.props;
        var currnt = evaluation.datas.content_object_content ? evaluation.datas.content_object_content.units[0] : null;
        return (
            <div className='questionItem'>
                {
                    // math
                    currnt && currnt.test === 'math' &&
                    <div className='content'>
                        Mathematics Test Directions
                        <br/>
                        You will have 60 minutes to complete this section.
                        SECTION DIRECTIONS: The first screen in this section contains instructions about the mathematics test. That screen is not part of the scored questions. You can return to the instructions at any time by selecting the Nav button at the top of the screen and then selecting Instr.
                        You are permitted to use a calculator on this test, and you may get it out now. Some types of calculators are prohibited. For example, you may not use any version of the TI-89. You are responsible for knowing if your calculator is permitted. Testing staff will check your calculator periodically during the test. If you use a prohibited calculator, you will be dismissed and your tests will not be scored.
                        You are also responsible for making sure your calculator is working properly. You will not be provided with backup batteries or a replacement calculator.
                        Do not share your calculator with another examinee. Do not connect your calculator in any way to the computer.
                        <br/>
                        If you need to use your backup calculator, raise your hand and testing staff will check it. You may have only one calculator on your workstation or in operation at a time. If you did not bring a backup calculator and yours malfunctions, continue testing.
                        If your calculator has games or other functions, you may not use those functions during the test; you may use only the mathematics functions. Keep your calculator flat on your workstation.
                        You may use your scratch paper on this test. You will hand that in to the room supervisor at the end of testing.
                        <br/>
                        Select the Next button to proceed.
                    </div>

                }
                {
                    // English
                    currnt && currnt.test === 'english' &&
                    <div className='content'>
                        English Test Directions
                        <br/>
                        You will have 45 minutes to complete this section.
                        SECTION DIRECTIONS: The first screen in this section contains instructions about the English test. That screen is not part of the scored questions. You can return to the instructions at any time by selecting the Nav button at the top of the screen and then selecting Instr.
                        You may use your scratch paper on this test. You will hand that in to the room supervisor at the end of testing.
                        Select the Next button to proceed.
                    </div>

                }
                {
                    // Reading
                    currnt && currnt.test === 'reading' &&
                    <div className='content'>
                        Reading Test Directions
                        <br/>
                        You may now resume testing. Remember, if you are wearing a watch with an alarm or have any other alarm device, it must remain turned off. If you have a cell phone or other electronic device, it must remain powered off and stored out of sight until you leave the test site.
                        Clear your workstation of everything except your testing computer, scratch paper, and pencil.
                        You will have 35 minutes to complete this section.
                        <br/>
                        SECTION DIRECTIONS: The first screen in this section contains instructions about the reading test. That screen is not part of the scored questions. You can return to the instructions at any time by selecting the Nav button at the top of the screen and then selecting Instr.
                        You may use your scratch paper on this test. You will hand that in to the room supervisor at the end of testing.
                        Select the Next button to proceed.
                    </div>

                }
                {
                    // Science
                    currnt && currnt.test === 'science' &&
                    <div className='content'>
                        Science Test Directions
                        <br/>
                        You will have 35 minutes to complete this section.
                        SECTION DIRECTIONS: The first screen in this section contains instructions about the science test. That screen is not part of the scored questions. You can return to the instructions at any time by selecting the Nav button at the top of the screen and then selecting Instr.
                        You may use your scratch paper on this test. You will hand that in to the room supervisor at the end of testing.
                        Select the Next button to proceed.
                    </div>

                }

            </div>
        );
    }
}
Info = connect((state) => ({
    evaluation: state.evaluation,
    currentEvaluation: state.currentEvaluation,
}), (dispatch) => ({
}))(Info);


class Item extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
        }

        this.answer = {
            index: '',
            value:''
        };

        const {answer,currentEvaluation} = props;
        const {answers} = answer;
        if(answers[currentEvaluation.page]){
            this.state.value = answers[currentEvaluation.page].value;
        }
    }


    _handlerNextQuestion = (action)=>{
        this._doSetAnswer(action);
    }

    _doSetAnswer(action) {
        const {actions,currentEvaluation} = this.props;
        this.answer.index = currentEvaluation.page;
        this.answer.value = this.state.value;
        console.log(action,actions)
        actions.setAnswer(currentEvaluation.page, this.answer, this.answer);
    }

    componentWillUnmount() {
        myEmitter.off('nextQuestion', this._handlerNextQuestion);
        myEmitter.off('prevQuestion', this._handlerNextQuestion);
    }

    componentDidMount() {
        myEmitter.on('nextQuestion', this._handlerNextQuestion);
        myEmitter.on('prevQuestion', this._handlerNextQuestion);
    }


    onChange = (e) => {
        console.log('radio checked', e.target.value);
        this.setState({
            value: e.target.value,
        });
    }
    render() {
        const radioStyle = {
            display: 'block',
            minHeight: '30px',
        };
        const {answer,evaluation,currentEvaluation} = this.props;
        return (
            <div className='questionItem'>
                <div className='content' dangerouslySetInnerHTML={{__html: ''}} />

                <div className='options'>
                    <p>
                        According to Figure 1, for any submersion time after 0 days, what is the order of the 4 deicers, from the deicer that produced the greatest average percent change in cylinder length to the deicer that produced the least average percent change in cylinder length?
                    </p>
                    <div className='options_group'>
                        <RadioGroup onChange={this.onChange} value={this.state.value}>
                            <Radio style={radioStyle} value={1}>Option A</Radio>
                            <Radio style={radioStyle} value={2}>Option B</Radio>
                            <Radio style={radioStyle} value={3}>Option C</Radio>
                        </RadioGroup>
                    </div>
                </div>
            </div>
        );
    }
}
Item = connect((state) => ({
    evaluation: state.evaluation,
    currentEvaluation: state.currentEvaluation,
    answer: state.answer,
}), (dispatch) => ({
    actions: bindActionCreators(setAnswer, dispatch),
}))(Item);


const QuestionWrapper = (WrappedComponent) => {
    class NewComponent extends Component {

        render() {
            return <WrappedComponent {...this.props}/>
        }
    }

    return connect(state => ({

    }))(NewComponent)
}

class QuestionItem extends Component {
    constructor(props) {
        super(props);
        // 初始状态
        this.state={
            value: ''
        }
    }

    _getQuestion() {
        const {evaluation,currentEvaluation} = this.props;
        var currnt = evaluation.datas.content_object_content ? evaluation.datas.content_object_content.units[currentEvaluation.page] : null;
        if (currnt && currnt.test === 'math') { // 单选填空题
            return QuestionWrapper(Match);
        }else if( currnt && currnt.test === 'science'){
            return QuestionWrapper(Science);
        }else if( currnt && currnt.test === 'english'){
            return QuestionWrapper(English);
        }else if( currnt && currnt.test === 'reading'){
            return QuestionWrapper(Reading);
        }
    }


    render() {
        const {evaluation,currentEvaluation,setAnswerFn, match} = this.props;
        // console.log(JSON.parse(evaluation.datas.content_object_content),'页面数据');
        const QuestionModel = currentEvaluation.page > -1 ? this._getQuestion() : '';
        return (
            <div className='questionItem' style={{position:'relative'}}>
                {/*<QuestionModel question={evaluation} index={currentEvaluation.page}/>*/}
                {currentEvaluation.page === -2 && <Info match={match}/> }
                {currentEvaluation.page === -1 && <Instr match={match} /> }
                {
                    currentEvaluation.page > -1 &&
                    <QuestionModel setAnswerFn={setAnswerFn} question={evaluation} index={currentEvaluation.page}/>
                }

            </div>
        );
    }
}
QuestionItem = connect((state) => ({
    evaluation: state.evaluation,
    currentEvaluation: state.currentEvaluation,
}), (dispatch) => ({

}))(QuestionItem);



export default QuestionItem;
